import {SxProps, Theme} from '@mui/material';

import {empionGreen, empionOrange} from '../../../../layouts/theme/EmpionColors';

export const getBenefitCardSx = (): SxProps<Theme> => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: 'none',
  border: `1px solid ${empionOrange[3]}`,
  backgroundColor: 'white',
});

export const getBenefitCardHeaderSx = (): SxProps<Theme> => ({
  backgroundColor: empionGreen[700],
  display: 'flex',
  alignItems: 'center',
});

export const BENEFIT_CHECK_COLOR = empionGreen[700];
export const BENEFIT_CHECK_UNCHECKED_COLOR = empionGreen[70];
